module.exports = __webpack_public_path__ + "images/credit-cards/credit-card.78ab357ad132b4742ccf.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/credit-cards/credit-card.png
// module id = TLMs
// module chunks = 0